import repository from "@/api/Seguridad.js";

export default {
  obtenerNoticia() {
    let url = `/noticias/`;
    return repository.get(url);
  }
};
